<div class="login-page">
  <div class="bg-orbs">
    <div class="orb orb-1"></div>
    <div class="orb orb-2"></div>
    <div class="orb orb-3"></div>
  </div>

  <div class="login-card">
    <!-- Left Panel -->
    <div class="panel-left">
      <div class="decor-ring decor-ring-1"></div>
      <div class="decor-ring decor-ring-2"></div>
      <div class="decor-ring decor-ring-3"></div>

      <div class="panel-left__body">
        <div class="clinic-logo">
          <img alt="logo" class="p-3" src="assets/images/logo.svg" style="filter: brightness(0) invert(1)" />
        </div>

        <div class="clinic-text">
          <h1 class="clinic-name">Dr. Got<br /><em>Home Clinic</em></h1>
          <p class="clinic-tagline">Advanced Care · Trusted Health</p>
        </div>

        <div class="ecg-wrap">
          <svg class="ecg-svg" preserveAspectRatio="none" viewBox="0 0 300 56">
            <path
              class="ecg-path"
              d="M0,28 L38,28 L43,24 L48,8 L54,48 L59,4 L64,52 L69,28 L115,28 L120,24 L125,8 L131,48 L136,4 L141,52 L146,28 L192,28 L197,24 L202,8 L208,48 L213,4 L218,52 L223,28 L300,28"
              fill="none"
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.8"
            />
          </svg>
        </div>

        <div class="stat-chips">
          <div class="chip">
            <span class="chip-dot"></span>
            <span>98.6°F</span>
          </div>
          <div class="chip">
            <span class="chip-dot"></span>
            <span>120 / 80</span>
          </div>
          <div class="chip">
            <span class="chip-dot"></span>
            <span>SpO₂ 99%</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Right Panel -->
    <div class="panel-right">
      <div class="panel-right__body">
        <div class="form-header">
          <span class="form-eyebrow">Clinic Management</span>
          <h2 class="form-title">Sign In</h2>
          <p class="form-sub">Enter your credentials to continue</p>
        </div>

        <form (ngSubmit)="onLogin()" [formGroup]="form" class="login-form">
          <div class="field-wrap field-wrap--1">
            <input
              autocomplete="username"
              class="field-input"
              formControlName="username"
              id="username"
              placeholder=" "
              type="text"
            />
            <label class="field-label" for="username">{{ 'page.login.field.username' | translate }}</label>
            <i class="pi pi-user field-icon"></i>
          </div>

          <div class="field-wrap field-wrap--2">
            <input
              autocomplete="current-password"
              class="field-input"
              formControlName="password"
              id="password"
              placeholder=" "
              type="password"
            />
            <label class="field-label" for="password">{{ 'page.login.field.password' | translate }}</label>
            <i class="pi pi-lock field-icon"></i>
          </div>

          <button [disabled]="form.invalid || loading()" class="login-btn" type="submit">
            @if (loading()) {
              <span class="btn-spinner"></span>
            } @else {
              <span>{{ 'page.login.button.login' | translate }}</span>
              <i class="pi pi-arrow-right"></i>
            }
          </button>
        </form>

        <p class="form-footer">© {{ currentYear }} Dr. Got Home Clinic</p>
      </div>
    </div>
  </div>
</div>
